export default __webpack_public_path__ + "static/media/san_pedro.530a2b15.jpg";